import {useEffect, useState} from 'react';

import {Space} from 'antd';

import logo from '../../../../assets/entry-exit-logo.png';

import './EntryExit.css';

export default function EntryExit() {
  const [scrollbarWidth, setScrollbarWidth] = useState(17);

  useEffect(() => {
    const node = document.getElementById('EntryExit');
    if (node) {
      setScrollbarWidth(node.offsetWidth - node.clientWidth);
    }
  }, [setScrollbarWidth]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widget.iata.hosting.netmatch.eu/scripts/v2/iata-timatic-widget-2.0.0.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Space
      id="EntryExit"
      style={{width: '100%', height: '100vh', overflow: 'auto', background: 'white'}}
      direction={'vertical'}
    >
      <div
        style={{
          background: 'white',
          height: '60px',
          width: `calc(100% - ${scrollbarWidth}px)`,
          padding: '5px 5px 5px 25px',
          borderBottom: '1px solid #F0F0F0',
        }}
      >
        <img style={{height: '100%'}} src={logo} alt="Crisis24 Horizon Logo" />
      </div>

      <div id="iata-timatic-widget" />

      <div style={{color: 'black', padding: '12px 24px 0', borderTop: '1px solid #F0F0F0'}}>
        Please note that this content is only available in English.
      </div>

      <div style={{color: 'black', padding: '0 24px'}}>
        The information in this document is provided “as-is” and is subject to change at any time. This document may
        also contain proprietary and confidential information that includes but is not limited to personally
        identifiable information (all such data collectively, the “Information”). Use of the Information is at your own
        risk. Crisis24 accepts no liability or responsibility for any errors or omissions in the Information arising out
        of partial or faulty transmission. This service may contain language translations performed by machine or
        artificial intelligence, and as a result, may contain translation imperfections or errors. Crisis24 disclaims
        all warranties related to any such translations, express or implied, including any warranties of accuracy,
        reliability, and any implied warranties of merchantability and fitness for a particular purpose. Crisis24 owns
        copyrights in the transmitted Information, and it may not be reproduced or redistributed in any form without the
        express written consent of Crisis24. If you have obtained this document in error, please delete it immediately.
      </div>
    </Space>
  );
}
